import Vue from "vue";
import _ from "lodash";
import App from "./App.vue";
import Utils from "./utils";
import Config from "./config";
import Modal from "./libs/modal";
import router from "./router";
import ImgLoaderDirective from "./libs/directives/img-loader-directive";
import Service from "./services";
import store from "./store";
import {
  sessionStorage,
  localStorage,
  localBaseOnKeyStorage
} from "./libs/storage";

import SelectDaycareModal from "./components/pages/orders/daycare/SelectServiceModal";
import SelectBeadhousModal from "./components/pages/orders/beadhouse/SelectServiceModal";
import SelectServiceModal from "./components/pages/orders/service/SelectServiceModal";
import SelectRestaurantModal from "./components/pages/orders/dinner/SelectRestaurantModal";
import SelectMenuItemsModal from "./components/pages/orders/dinner/SelectMenuItemsModal";
import SelectSkuModal from "./components/pages/orders/dinner/SelectSkuModal";
import OrderCancelModal from "./components/pages/orders/OrderCancelModal";
import WorkorderHandleModal from "./components/pages/workorder/WorkorderHandleModal";

import el from "./libs/ele/src/index";

el.install(Vue);

require("./libs/ele/sass/index.scss");
require("./css/index.styl");

// check version
if (process.env.NODE_ENV !== "development") {
  let version = process.APP_VARIABLES.VERSION;
  Service.callApiService(
    Utils.getLocationOrigin() + "/version.txt",
    "GET",
    null,
    null,
    null,
    "text"
  ).then(rsp => {
    if (rsp && rsp.data && version) {
      let retryTimes = sessionStorage.get("ResourceReloadTimes") || 0;
      // 重试超过5次，不再重新加载
      if (retryTimes > 4) return;
      let v1 = version.split(".");
      let v2 = rsp.data.split(".");
      for (let i = 0; i < v1.length; i++) {
        if (+v1[i] < +v2[i]) {
          sessionStorage.set("ResourceReloadTimes", ++retryTimes);
          window.location.reload(true);
          return;
        }
      }
    }
  });
  setTimeout(() => {
    sessionStorage.remove("ResourceReloadTimes");
  }, 5000);
}

Vue.config.productionTip = false;

Vue.use(ImgLoaderDirective);

Vue.use(Modal);

Vue.prototype.Utils = Utils;
Vue.prototype.Service = {
  login: Service.login,
  pay: Service.pay,
  call: Service.callApiService
};
Vue.prototype.sessionStorage = sessionStorage;
Vue.prototype.localStorage = localStorage;
Vue.prototype.localBaseOnKeyStorage = localBaseOnKeyStorage;
Vue.prototype.Config = Config;

Vue.prototype.routeTo = location => {
  router.push(location);
};
Vue.prototype.routeReplace = location => {
  router.replace(location);
};
Vue.prototype.routeBack = idx => {
  router.go(idx || -1);
};
let orderStates = [
  { id: 0, name: "待支付" },
  { id: 1, name: "已支付" },
  { id: 2, name: "派单中" },
  { id: 3, name: "已派单" },
  { id: 4, name: "服务中" },
  { id: 5, name: "服务完成" },
  { id: 6, name: "待评价" },
  { id: 7, name: "已评价" },
  { id: 8, name: "已关闭" },
  { id: 9, name: "取消" }
];
let oldManType = [
  { id: 0, name: "社会化老人" },
  { id: 1, name: "A类老人" },
  { id: 2, name: "B类老人" },
  { id: 3, name: "C类老人" }
];
let unitOfTimes = [
  { id: 0, name: "分钟" },
  { id: 1, name: "小时" },
  { id: 2, name: "天" }
];
let workorderType = [
  { id: 1, name: "电话咨询" },
  { id: 2, name: "订单工单" },
  { id: 3, name: "主动外呼" },
  { id: 4, name: "投诉" },
  { id: 5, name: "紧急呼叫报警" },
  { id: 6, name: "越界报警" },
  { id: 7, name: "低电量报警" },
  { id: 8, name: "心率报警" },
  { id: 9, name: " 血压报警" },
  { id: 0, name: "其它" }
];
let workorderStatus = [
  { id: 0, name: "未分配" },
  { id: 1, name: "未受理" },
  { id: 2, name: "受理中" },
  { id: 3, name: "已办结" },
  { id: 4, name: "已关闭" }
];
let workorderOperationType = [
  { id: 0, name: "创建工单" },
  { id: 1, name: "删除工单" },
  { id: 2, name: "合并工单" },
  { id: 3, name: "重新打开工单" },
  { id: 4, name: "转交工单" },
  { id: 5, name: "关闭工单" },
  { id: 6, name: "受理工单" },
  { id: 7, name: "备注工单" },
  { id: 8, name: "编辑工单" },
  { id: 9, name: "质检工单" },
  { id: 10, name: "办结工单" }
];
Vue.mixin({
  filters: {
    sexFilter(val) {
      return val === true ? "男" : "女";
    },
    cycleFilter(val) {
      switch (val) {
        case 0:
          return "单次";
          break;
        case 1:
          return "包月";
          break;
      }
    },
    phoneFilter(val) {
      let str = "";
      if (
        val === null ||
        val === "null" ||
        val === undefined ||
        val === "" ||
        val === "0001-01-01"
      ) {
        return "--";
      }
      if (val.length == 11) {
        str = `${val.substr(0, 3)}****${val.substr(7, 4)}`;
      } else {
        str = val;
      }
      return str;
    },
    olderTypeFilter(val) {
      switch (val) {
        case 0:
          return "D类老人";
          break;
        case 1:
          return "A类老人";
          break;
        case 2:
          return "B类老人";
          break;
        case 3:
          return "C类老人";
          break;
      }
    },
    /**订单类型 */
    orderTypeFilter(value) {
      let result;
      switch (value) {
        case 0:
          result = "其他";
          break;
        case 1:
          result = "上门服务";
          break;
        case 2:
          result = "爱心午餐";
          break;
        case 3:
          result = "送餐";
          break;
        case 4:
          result = "养老机构";
          break;
        default:
          result = null;
          break;
      }
      return result;
    },
    /**订单状态 */
    orderStatusFilter(val) {
      switch (parseInt(val)) {
        case 0:
          return "待支付";
        case 1:
          return "已支付";
        case 2:
          return "待派单";
        case 3:
          return "已派单";
        case 3:
          return "服务中";
        case 5:
          return "服务完成";
        case 6:
          return "待评价";
        case 7:
          return "已评价";
        case 8:
          return "已关闭";
        case 9:
          return "已取消";
      }
    }
  },
  computed: {
    orderStates() {
      return orderStates;
    },
    workorderType() {
      return [
        { id: 1, name: "电话咨询" },
        { id: 2, name: "订单工单" },
        { id: 3, name: "主动外呼" },
        { id: 4, name: "投诉" },
        { id: 0, name: "其它" }
      ];
    },
    alarmorderType() {
      return [
        { id: 5, name: "紧急呼叫报警" },
        { id: 6, name: "越界报警" },
        { id: 7, name: "低电量报警" },
        { id: 8, name: "心率报警" },
        { id: 9, name: " 血压报警" },
        { id: 0, name: "其它" }
      ];
    },
    workorderStatus() {
      return workorderStatus;
    },
    canCreateOrder() {
      let callInfo = store.state.callInfo;
      let state = store.state.callState;
      return (
        [
          "WORKNOTREADY",
          "ALERTING",
          "TALKING",
          "HELD",
          5,
          6,
          8,
          9,
          10,
          12
        ].indexOf(state) > -1 &&
        ((callInfo.inout === "in" && callInfo.caller) ||
          (callInfo.inout === "out" && callInfo.callee))
      );
    },
    // 当前通话的用户电话号码
    currentUserPhone() {
      let callInfo = store.state.callInfo;
      let state = store.state.callState;
      return (
        ([
          "WORKNOTREADY",
          "ALERTING",
          "TALKING",
          "HELD",
          5,
          6,
          8,
          9,
          10,
          12
        ].indexOf(state) > -1 &&
          ((callInfo.inout === "in" && callInfo.caller) ||
            (callInfo.inout === "out" && callInfo.callee))) ||
        null
      );
    }
  },
  methods: {
    // type 1 服务  2  订餐  3 养老机构  4日间照料中心
    createOrder(type) {
      if (this.currentUserPhone) {
        // 检索老人信息是否存在
        this.Service.call("theold/detail/byphone", "GET", {
          phone: this.olderPhone ? this.olderPhone : this.currentUserPhone
        })
          .then(data => {
            if (data && data.gid) {
              switch (type) {
                case 1:
                  this.routeTo({
                    path: "/orders/service/create",
                    query: {
                      tel: this.olderPhone
                        ? this.olderPhone
                        : this.currentUserPhone
                    }
                  });
                  break;
                case 2:
                  this.routeTo({
                    path: "/orders/dinner/create",
                    query: {
                      tel: this.olderPhone
                        ? this.olderPhone
                        : this.currentUserPhone
                    }
                  });
                  break;
                case 3:
                  this.routeTo({
                    path: "/orders/beadhouse/create",
                    query: {
                      tel: this.olderPhone
                        ? this.olderPhone
                        : this.currentUserPhone
                    }
                  });
                  break;
                case 4:
                  this.routeTo({
                    path: "/orders/daycare/create",
                    query: {
                      tel: this.olderPhone
                        ? this.olderPhone
                        : this.currentUserPhone
                    }
                  });
              }
            } else {
              this.$message.error("老人信息不存在，请先录入");
            }
          })
          .catch(() => {
            this.$message.error("老人信息不存在，请先录入");
          });
      } else {
        this.$message.error("在通话时或老人列表点击下单使用此功能");
      }
    },
    getOrderStateName(code) {
      code = +code;
      for (let item of orderStates) {
        if (item.id === code) {
          return item.name;
        }
      }
    },
    getOrderStates() {
      return [...orderStates];
    },
    getOldManTypes() {
      return [...oldManType];
    },
    getNameOfUnitTime(val) {
      let item = unitOfTimes[+val];
      return (item && item.name) || "";
    },
    getNameOfOldManType(val) {
      let item = oldManType[+val];
      return (item && item.name) || "";
    },
    getFormattedTime(seconds) {
      let s = seconds % 60;
      let m = Math.floor(seconds / 60) % 60;
      let h = Math.floor(seconds / 60 / 60);
      return `${_.padStart(h, 2, "0")}:${_.padStart(m, 2, "0")}${_.padStart(
        s,
        2,
        "0"
      )}`;
    },
    getWorkorderTypes() {
      return [...workorderType];
    },
    getNameOfWorkorderType(val) {
      let item = workorderType[(+val + 6) % 7];
      return (item && item.name) || "";
    },
    getWorkorderStatus() {
      return [...workorderStatus];
    },
    getNameOfWorkorderStatus(val) {
      let item = workorderStatus[+val];
      return (item && item.name) || "";
    },
    //------------------------------------------------------------------------------------------------------------------------------------
    getTagList(list, searchObj) {
      return Object.entries(searchObj).filter((item, index) => {
        if (item[1] !== null && item[1] !== undefined && item[1] !== "") {
          for (let i = 0; i < list.length; i++) {
            if (item[0] == list[i].engName) {
              if (item[0] == "status") {
                item[1] = item[1] == "0" ? "待评估" : "已评估";
              }
              if (item[0] == "type") {
                item[1] =
                  item[1] === 1
                    ? "A类老人"
                    : item[1] === 2
                    ? "B类老人"
                    : item[1] === 3
                    ? "C类老人"
                    : item[1] === 0
                    ? "D类老人"
                    : "";
              }
              item.push(list[i].cnName);
            }
          }
          return true;
        }
      });
    },
    getWorkorderTag(list, searchObj) {
      return Object.entries(searchObj).filter((item, index) => {
        if (item[1] !== null && item[1] !== undefined && item[1] !== "") {
          for (let i = 0; i < list.length; i++) {
            if (item[0] == list[i].engName) {
              if (item[0] == "status") {
                item[1] === 1
                  ? "未受理"
                  : item[1] === 2
                  ? "受理中"
                  : item[1] === 3
                  ? "已办结"
                  : item[1] === 4
                  ? "已关闭"
                  : item[1] === 0
                  ? "未分配"
                  : "";
              }
              if (item[0] == "type") {
                item[1] =
                  item[1] === 1
                    ? "电话咨询"
                    : item[1] === 2
                    ? "订单工单"
                    : item[1] === 3
                    ? "主动外呼"
                    : item[1] === 4
                    ? "投诉"
                    : item[1] === 5
                    ? "紧急呼叫报警"
                    : item[1] === 6
                    ? "越界报警"
                    : item[1] === 7
                    ? "低电量报警"
                    : item[1] === 8
                    ? "心率报警"
                    : item[1] === 9
                    ? "血压报警"
                    : item[1] === 0
                    ? "其它"
                    : "";
              }
              item.push(list[i].cnName);
            }
          }
          return true;
        }
      });
    },
    getMoneyTag(list, searchObj) {
      return Object.entries(searchObj).filter((item, index) => {
        if (item[1] !== null && item[1] !== undefined && item[1] !== "") {
          for (let i = 0; i < list.length; i++) {
            if (item[0] == list[i].engName) {
              if (item[0] == "type") {
                item[1] =
                  item[1] === 1
                    ? "补助发放"
                    : item[1] === 2
                    ? "结算记录"
                    : item[1] === 3
                    ? "充值记录"
                    : item[1] === 0
                    ? "消费记录"
                    : item[1] === 4
                    ? "清算记录"
                    : "";
              }
              item.push(list[i].cnName);
            }
          }
          return true;
        }
      });
    },
    getLosscallSearch() {
      return [
        { cnName: "座席名称", engName: "agentNames" },
        { cnName: "未接通原因", engName: "type" },
        { cnName: "未接通来电开始时间", engName: "startTime" },
        { cnName: "未接通来电结束时间", engName: "endTime" },
        { cnName: "处理状态", engName: "status" }
      ];
    },
    getOlderSearch() {
      return [
        { cnName: "姓名", engName: "name" },
        { cnName: "身份证", engName: "idcard" },
        { cnName: "手机号", engName: "phone" },
        { cnName: "老人类型", engName: "type" },
        { cnName: "所属社区", engName: "district" },
        { cnName: "老人标签", engName: "tagNames" },
        { cnName: "一键通号码", engName: "pushToTalk" }
      ];
    },
    getOrderSearch() {
      return [
        { cnName: "账单时间", engName: "timeRange" },
        { cnName: "账单类型", engName: "type" }
      ];
    },
    getProviderSearch() {
      return [{ cnName: "名称", engName: "providerName" }];
    },
    getFaceUpdateSearch() {
      return [{ cnName: "姓名", engName: "theOldName" }];
    },
    getEvalSearch() {
      return [{ cnName: "评价时间", engName: "timeRange" }];
    },
    deleteOneSearch(item, form) {
      for (var i in form) {
        if (item === i) {
          form[i] = "";
        }
      }
      return form;
    },
    getNameOfWorkorderOperationType(val) {
      let item = workorderStatus[+val];
      return (item && item.name) || "";
    }
  }
});

// 在此处注册所有用到的Modal
let modals = {
  SelectDaycareModal,
  SelectBeadhousModal,
  SelectServiceModal,
  SelectRestaurantModal,
  SelectMenuItemsModal,
  SelectSkuModal,
  OrderCancelModal,
  WorkorderHandleModal
};
for (let key in modals) {
  if (modals.hasOwnProperty(key)) {
    Modal.registerModal(key, modals[key]);
  }
}

let auth;
auth = localStorage.get("auth");
if (!auth) {
  auth = sessionStorage.get("auth");
}

if (auth && auth.token) {
  store.commit("setAuth", auth);
}

router.beforeEach((to, from, next) => {
  store.state.currentSearchForm = {};
  let needLogin = to.matched.some(record => record.meta.auth);
  if (!needLogin) {
    next();
    return;
  }
  if (!store.state.auth) {
    next({
      path: "/login",
      query: { backUrl: to.fullPath }
    });
  } else {
    next();
  }
});

//-------------------
import BaseTable from "@/components/common/base-table.vue";
Vue.component("BaseTable", BaseTable);
import autoTable from "@/components/common/base-table-auto.vue";
Vue.component("AutoTable", autoTable);
import NavTopTag from "@/components/common/nav-top-tag";
Vue.component("NavTopTag", NavTopTag);
import BaseStatistics from "@/components/common/base-statistics.vue";
Vue.component("BaseStatistics", BaseStatistics);
import baseFunc from "./funcs/base-func.js";
import TopTap from "@/components/common/TopTap";
Vue.component("TopTap", TopTap);
Vue.prototype.$baseFunc = baseFunc;
import xiaLaList from "./funcs/xiaLaList.js";
Vue.prototype.$xiaLaList = xiaLaList;
import FormFilter from "./funcs/formFilter";
Vue.prototype.$filter = FormFilter;
import axios from "axios";
Vue.prototype.$axios = axios;
//----  从身份证自动获取出生年月日
import getInfoFromId from "@/funcs/getInfoFromId";
Vue.prototype.$getInfoFromId = getInfoFromId;
import FormValidate from "./utils/form-validate";
Vue.prototype.$FormValidate = FormValidate;
//表格进阶
import baseTableOne from "@/components/base-table-one";
Vue.use(baseTableOne);
//引入图片预览插件
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source"
  }
});

//----------------------

// 百度统计路由上报 
router.afterEach((to, from) => { 
    window._hmt && window._hmt.push(['_trackPageview', to.fullPath]); 
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
